import d3 from "@/assets/d3";

export function drawMatrixCell(data, cellContainer) {
  const subcellHeight = data.height / data.cellData.length;
  const subcellWidth = data.width / data.cellData.length;

  const maxValue = Math.max.apply(null, ...data.cellData);
  const color = d3.scaleLinear([1, maxValue], ["#ddd", "#888"]);

  for (let i = 0; i < data.cellData.length; i++) {
    for (let j = 0; j < data.cellData[i].length; j++) {
      let matrixCellContainer = cellContainer.select(
        `rect[matrix-cell="${i}-${j}"]`
      );
      if (matrixCellContainer.empty()) {
        matrixCellContainer = cellContainer.append("rect").attrs({
          "matrix-cell": `${i}-${j}`,
          x: 0,
          y: 0,
          width: 0,
          height: 0
        });
      }
      matrixCellContainer.attrs({
        x: j * subcellWidth,
        y: i * subcellHeight,
        height: subcellHeight,
        width: subcellWidth
      });
      if (i === j) {
        // Draw diagonal
        matrixCellContainer.attrs({
          class: "matrix-diagonal-cell",
          fill: "url(#diagonalHatch)"
        });
      } else if (data.cellData[i][j] > 0) {
        // Draw adj mat cell
        matrixCellContainer.attrs({
          fill: color(data.cellData[i][j])
        });
      } else {
        // Draw empty cell
        matrixCellContainer.attrs({
          class: "matrix-empty-cell"
        });
      }
    }
  }
}
//TODO: remove param dataService and find a different solution
export function drawHorizontalBarsCell(
  data,
  cellContainer,
  globalMax,
  callbacks,
  dataService
) {
  const yScale = d3
    .scaleBand()
    .domain(data.cellData.map(r => r.id))
    .range([0, data.height])
    .padding(0.1);

  const xScale = d3
    .scaleLinear()
    .domain([0, globalMax.grouped])
    .range([0, data.width - 1]);

  let bgContainer = cellContainer.select(
    "rect.horizontal-bars-container-background"
  );
  if (bgContainer.empty()) {
    bgContainer = cellContainer.append("rect").attrs({
      x: 0,
      y: 0,
      class: "horizontal-bars-container-background"
    });
  }

  bgContainer.transition().attrs({
    height: data.height,
    width: data.width
  });

  let barsContainer = cellContainer.select("g.horizontal-bars-container");
  if (barsContainer.empty()) {
    barsContainer = cellContainer.append("g").attrs({
      class: "horizontal-bars-container"
    });
  }

  let barData = barsContainer
    .selectAll("rect")
    .data(data.cellData, d => d.id)
    .join("rect");

  let barContainer = barData
    // .transition()
    .attrs({
      x: 0,
      y: d => yScale(d.id),
      width: d => xScale(d.value),
      height: yScale.bandwidth(),
      "node-id": d => d.id,
      "column-id": data.column_id,
      "row-id": data.row_id,
      class: "node-bar"
    })
    .on("mouseover", callbacks.over)
    .on("mouseout", callbacks.out);

  if (barContainer.selectAll("title").empty()) {
    const v = data.row_id;
    const t = data.column_id;
    const l = data.cellData[0].value;
    barContainer
      .append("title")
      .text(
        d =>
          `Timestep: t${t}, variant: v${v}, node: ${
            dataService.nodeIdToName[d.id]
          }, degree: ${l}`
      );
  }
}
//TODO: remove param dataService and find a different solution
export function drawVerticalBarsCell(
  data,
  cellContainer,
  globalMax,
  callbacks,
  dataService
) {
  const xScale = d3
    .scaleBand()
    .domain(data.cellData.map(r => r.id))
    .range([0, data.width])
    .padding(0.1);

  const yScale = d3
    .scaleLinear()
    .domain([0, globalMax.grouped])
    .range([0, data.height - 1]);

  let bgContainer = cellContainer.select(
    "rect.vertical-bars-container-background"
  );
  if (bgContainer.empty()) {
    bgContainer = cellContainer.append("rect").attrs({
      x: 0,
      y: 0,
      class: "vertical-bars-container-background"
    });
  }

  bgContainer.transition().attrs({
    height: data.height,
    width: data.width
  });

  let barsContainer = cellContainer.select("g.vertical-bars-container");
  if (barsContainer.empty()) {
    barsContainer = cellContainer.append("g").attrs({
      class: "vertical-bars-container"
    });
  }

  let barData = barsContainer
    .selectAll("rect")
    .data(data.cellData, d => d.id)
    .join("rect");

  let barContainer = barData
    // .transition()
    .attrs({
      x: d => xScale(d.id),
      y: d => data.height - yScale(d.value),
      width: xScale.bandwidth(),
      height: d => yScale(d.value),
      "node-id": d => d.id,
      "column-id": data.column_id,
      "row-id": data.row_id,
      class: "node-bar"
    })
    .on("mouseover", callbacks.over)
    .on("mouseout", callbacks.out);

  if (barContainer.selectAll("title").empty()) {
    const v = data.row_id;
    const t = data.column_id;
    const l = data.cellData[0].value;
    barContainer
      .append("title")
      .text(
        d =>
          `Timestep: t${t}, variant: v${v}, node: ${
            dataService.nodeIdToName[d.id]
          }, degree: ${l}`
      );
  }
}
export function drawSingleBarCell(data, cellContainer) {
  cellContainer = cellContainer
    .selectAll("rect")
    .data(data.cellData)
    .join("rect");
  cellContainer.attrs({
    width: data.width,
    height: data.cellData[0].bar_height,
    y: data.cellData[0].filler_height
  });

  cellContainer
    .select("rect.cell-filler")
    .transition()
    .attrs({
      height: data.cellData[0].filler_height,
      width: data.width
    });

  const v = data.row_id;
  const t = data.column_id;
  const l = data.cellData[0].value;
  cellContainer
    .select("title")
    .text(`Timestep: t${t}, variant: v${v}, degree: ${l}`);
}
